import React, { ChangeEvent } from 'react'

export function SelectMonthYear({ date, localeUtils, onChange, range }) {
  const fromMonth = range.from
  const toMonth = range.to
  const months = localeUtils.getMonths()

  const years: number[] = []
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i)
  }

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { year, month } = (e.target.form as unknown) as {
      year: HTMLSelectElement
      month: HTMLSelectElement
    }
    onChange(new Date(parseInt(year.value, 10), parseInt(month.value, 10)))
  }

  return (
    <form className="DayPicker-Caption">
      <select
        name="month"
        onBlur={handleChange}
        onChange={handleChange}
        value={date.getMonth()}
      >
        {months.map((month, i) => (
          <option
            key={month}
            value={i}
            aria-selected={date.getMonth() === month}
          >
            {month}
          </option>
        ))}
      </select>
      <select
        name="year"
        onBlur={handleChange}
        onChange={handleChange}
        value={date.getFullYear()}
      >
        {years.map((year) => (
          <option
            key={year}
            value={year}
            aria-selected={date.getFullYear() === year}
          >
            {year}
          </option>
        ))}
      </select>
    </form>
  )
}
